import React, { useContext } from "react";
import Loading from "../../Loading";
import MonthPicker from "./MonthPicker";
import SalaryDetailDialog from "./SalaryDetailDialog";
import "./salaries.css";
import Location from "../../components/Location";
import FormatDate from "../../components/FormatDate";
import Time from "../../components/Time";
import StaffChooserContext from "../../components/StaffChooserContext";
import VND from "../../components/VND";
import { CenterContext, StaffContext } from "../../../../Context";
import useDBO from "../../hooks/useDBO";



export default function Salaries(props) {
  const { center } = useContext(CenterContext);
  const [year, setYear] = React.useState(new Date().getFullYear());
  const [month, setMonth] = React.useState(new Date().getMonth());
  const [open, setOpen] = React.useState(false);
  const [selectedUser, setSelectedUser] = React.useState(undefined);
  const shifts = useDBO(`/salaries/${year}/${month + 1}`);
  const { staff } = useContext(StaffContext)
  let managers = staff.map(s => ({ ...s, staff: [] }))
  
   console.log(shifts);
  if (shifts.loading) return <Loading />;
 
  const noManager = [];

  const noUser = []

  for (let shift of shifts.get) {
    if (shift.user === null) {
      noUser.push(shift)
    } else {
      let manager = managers.find((m) => m._id === shift.user.reportsTo);
      if (shift.user.reportsTo && manager) {
      
      
        if (!manager.staff) manager.staff = [];
        let staff = manager.staff.find((s) => s._id === shift.user._id);
        if (staff) {
          if (!staff.shifts) staff.shifts = [];
          staff.shifts.push(shift);
        } else {
          manager.staff.push({
            _id: shift.user._id,
            name: shift.user.name,
            salary: shift.user.salary,
            bankAccountBank: shift.user.bankAccountBank || "No bank account",
            bankAccountNumber: shift.user.bankAccountNumber || "",
            shifts: [shift],
          });
        }
      } else {
        let staff = noManager.find((s) => s._id === shift.user._id);
        if (staff) {
          if (!staff.shifts) staff.shifts = [];
          staff.shifts.push(shift);
        } else {
          noManager.push({
            _id: shift.user._id,
            name: shift.user.name,
            salary: shift.user.salary,
            bankAccountBank: shift.user.bankAccountBank || "No bank account",
            bankAccountNumber: shift.user.bankAccountNumber || "",
            shifts: [shift],
          });
        }
      }
    }
  }

  managers.push({
    name: "No manager",
    staff: noManager,
  });


  return (
    <div>
      <DrawTitle
        month={month}
        year={year}
        setMonth={setMonth}
        setYear={setYear}
        shifts={shifts}
        {...props}
      />
      {noUser.length > 0 && <div>
        <div style={{ color: "red" }}>Shifts with no staff member</div>
        {noUser.map(shift =>
          <DrawNoUser shift={shift}  key={shift._id} />)
        }</div>}
      {managers.map((manager) => (
        <DrawManager
          manager={manager}
          setOpen={setOpen}
          setSelectedUser={setSelectedUser}
          key={manager._id}
        />
      ))}
      {/*   <DrawManager manager={noManager} noManager /> */}
      <SalaryDetailDialog
        open={open}
        setOpen={setOpen}
        shifts={shifts.filter((shift) => shift.user && shift.user._id === selectedUser)}
        center={center}
      />
    </div>
  );
}

function DrawTitle(props) {
  console.log(props.shifts)
   const { locations } = useContext(CenterContext);
  return (
    <div className="dflex-sb" style={{alignItems:"center"}}>
      <h1>Part Time Salaries</h1>
      <h1><VND value={props.shifts.reduce("total")} /></h1>
      <div>
        {locations.map(l => <div key={l._id}>{l.name}: <VND value={props.shifts.filter(s => s.location === l._id).reduce((a,b)=> a + b.total,0) } /></div>)}
      </div>
      <MonthPicker {...props} />
    </div>
  );
}
function DrawManager(props) {
  let { manager, noManager } = props;

  if (!manager.staff) return <div></div>;
  if (manager.staff && manager.staff.length < 1) return <div></div>;
  let total = 0;
  manager.staff.forEach((s) => {
    s.shifts.forEach((shift) => {
      total += shift.total
    });
  });
  return (
    <div>
      <h2 className="text-xl text-cyan-700 mt-2 mb-2">{noManager ? "No manager" : manager.name} </h2>
      <hr />
      <div>
        <div style={{ display: "flex", fontSize: 11 }}>
          <div style={{ width: 200 }}>Name</div>
          <div style={{ width: 200 }}>Salary</div>
          <div style={{ width: 200 }}>Shifts</div>
          <div style={{ width: 200 }}>Hours</div>
          <div style={{ flexGrow: 1, textAlign: "right" }}>Total Amount</div>
        </div>
        {manager.staff.map((staffMember) => (
          <div key={staffMember._id}>
            <DrawStaff
              member={staffMember}
              {...props}
            />
            <hr />
          </div>
        ))}
      </div>

      <div style={{ display: "flex", justifyContent: "space-between"}} className="p-2 font-bold">
        <h3>Total</h3>
        <h3>
         
          <VND value={total} />
        </h3>
      </div>
      <hr></hr>
    </div>
  );
}

function DrawStaff(props) {
  let { member, setOpen, setSelectedUser } = props;
  let totalHours = member.shifts.reduce((a, b) => a + b.hours, 0);
  let totalSalary = member.shifts.reduce((a, b) => a + b.total, 0);
  return (
    <div
      style={{ display: "flex" }}
      className="staff p-2"
      onClick={() => {
        setSelectedUser(member._id);
        setOpen(true);
      }}
    >
      <div style={{ width: 200 }}>{member.name}</div>
      <div style={{ width: 200 }}>
        <VND value={member.salary} />
      </div>
      <div style={{ width: 200 }}>{member.shifts.length}</div>
      <div style={{ width: 200 }}>{totalHours.toFixed(1)}</div>
      <div style={{ width: 200 }}>{member.bankAccountBank}</div>
      <div style={{ flexGrow: 1 }}>{member.bankAccountNumber}</div>
      <div >
        <VND value={totalSalary} />
      </div>
    </div>
  );
}

function DrawNoUser({ shift,setUpdate }) {
  const [user,setUser] = React.useState("")

  return (
    <div style={{ display: "flex", alignItems:"center",gap: 20 }}>
      <div>
        <Location id={shift.location} />
      </div>
      <div>
        <FormatDate value={shift.date} />
      </div>
      <div>
        Start: <Time time={shift.startTime} />
      </div>
      <div>
        End: <Time time={shift.endTime} />
      </div>
      <StaffChooserContext
        label="Person"
        style={{ width: 150 }}
        value={user}
        setValue={setUser}
        size="small"
      />
     {/*  <Button
        onClick={() => {
          net
            .post(`/shifts/${shift._id}`, { user })
        }}
      >
        Choose
      </Button> */}
    </div>
  );
}
